import { ListReducer, mergeEntities } from '../../store';

import { transformUserRecentProjectsAndContests } from './recent-project-and-contests.transformers';

export const navigationUserRecentProjectsAndContestsReducer: ListReducer<
  'navigationUserRecentProjectsAndContests'
> = (state = {}, action) => {
  switch (action.type) {
    case 'API_FETCH_SUCCESS':
      if (
        action.payload &&
        action.payload.ref.path[0] === 'navigationUserRecentProjectsAndContests'
      ) {
        const ref = action.payload.ref;
        const data = <any>action.payload.data;
        return mergeEntities<'navigationUserRecentProjectsAndContests'>(
          state,
          transformUserRecentProjectsAndContests(data),
          ref,
        );
      }
      return state;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build/webapp/src/app/@shared/datastore/navigation/recent-projects-and-contests/recent-projects-and-contests.reducer.ts